import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccClaimImport } from '../../models/icc/icc-claim-import.model';
import { IccImportFilters } from '../../models/icc/icc-import-settings.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';

export class PagedIccClaimImports implements PagedResults {
  claimImports: IccClaimImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.claimImports;
  }
}

@Injectable()
export class IccClaimImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccClaimImport> {
    return this.http.get<IccClaimImport>(`${environment.captureApi.url}/icc/claim_imports/${id}`);
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: IccImportFilters = null
  ): Observable<PagedIccClaimImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccClaimImports>(
      `${environment.captureApi.url}/icc/claim_imports?${params.toString()}`
    );
  }

  create(clientId: number, thirdPartyAdministerId: number, name: string, signedId: string): Observable<IccClaimImport> {
    return this.http.post<IccClaimImport>(`${environment.captureApi.url}/icc/claim_imports`, {
      claimImport: { clientId, thirdPartyAdministerId, name, signedId },
    });
  }

  update(id, name): Observable<IccClaimImport> {
    return this.http.put<IccClaimImport>(`${environment.captureApi.url}/icc/claim_imports/${id}`, {
      claimImport: { name },
    });
  }

  cancel(id): Observable<IccClaimImport> {
    return this.http.patch<IccClaimImport>(`${environment.captureApi.url}/icc/claim_imports/${id}/cancel`, {});
  }
}
